export default function DebounceFunc(event: string, func: Function) {
  const timing = setTimeout(() => {
    func(event);
  }, 300);
  return () => clearTimeout(timing);
}
